import React from 'react'
import { CircleWiseFilterForm } from '../../trips/filter_forms/CircleWiseFilterForm'
import { useTripStore } from '../../store/useTripStore';
import MUITable from '../../../../../Common/MUITable';
import { ExportCircleWiseReport } from './ExportCircleWiseReport';
import { useNavigate } from 'react-router-dom';
import { TableLoader } from '../../../../../Common/ShimmerLoader';
import { formatDateTimeWithoutSec, getCurrentDateTime, getCurrentDateTime1 } from '../../../../../Common/helper/helpar';
export const CircleWiseSATsReports = () => {
  
  const navigate = useNavigate();
  const {
    isFetchingCircleWiseTrips,
    circleWiseTrips,
    fetchTripDetails,
    fetchTotalTripDetails
  } = useTripStore();

  const filters = JSON.parse(localStorage.getItem("sat-trips-circle-filters"));

  const circleWiseHeaderColumns = [
    {
      label: "Zone",
      field: "zoneName",
      render: row => row.zoneName ?? "N/A",
    },
    {
      label: "Circle",
      field: "circleName",
      render: row => row.circleName,
    },

    {
      label: "Reported at TS/SCTP",
      field: "reportedatTSSCTP",
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "5",
              isUnique: true,
              ZoneId: row.circleName === "Total" ? "" : row.zoneId,
              CircleId: row.circleName === "Total" ? "" : row.circleId,
            }
            fetchTripDetails(params)
            navigate("/sat-inner-trip-report", { state: { ...filters, colName: "Reported at TS/SCTP", circleName: row.circleName } })
          }}
        >
          {row.reportedatTSSCTP ?? "N/A"}
        </div>
      ),
    },
    {
      label: "Total Trips",
      field: "totalTrips",
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "5",
              isUnique: false,
              ZoneId: row.circleName === "Total" ? "" : row.zoneId,
              CircleId: row.circleName === "Total" ? "" : row.circleId,
            }
						fetchTripDetails(params)
            navigate("/sat-total-inner-trip-report", { state: { ...filters, colName: "Total Trips", circleName: row.circleName } })
          }}
        >
          {row.totalTrips?? "N/A"}
        </div>
      ),
    },
    {
      label: "1 Trip",
      field: "oneTrip",
      sortable: true,
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "1",
              ZoneId: row.circleName === "Total" ? "" : row.zoneId,
              CircleId: row.circleName === "Total" ? "" : row.circleId,
            }
            fetchTripDetails(params)
            navigate("/sat-inner-trip-report", { state: { ...filters, colName: "1 Trip", circleName: row.circleName } })
          }}
        >
          {row.oneTrip?? "N/A"}
        </div>
      ),
    },
    {
      label: "2 Trips",
      field: "twoTrips",
      sortable: true,
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "2",
              ZoneId: row.circleName === "Total" ? "" : row.zoneId,
              CircleId: row.circleName === "Total" ? "" : row.circleId,
            }
            fetchTripDetails(params)
            navigate("/sat-inner-trip-report", { state: { ...filters, colName: "2 Trips", circleName: row.circleName } })
          }}
        >
          {row.twoTrips?? "N/A"}
        </div>
      ),
    },
    {
      label: "3 Trips",
      field: "threeTrips",
      sortable: true,
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "3",
              ZoneId: row.circleName === "Total" ? "" : row.zoneId,
              CircleId: row.circleName === "Total" ? "" : row.circleId,
            }
            fetchTripDetails(params)
            navigate("/sat-inner-trip-report", { state: { ...filters, colName: "3 Trips", circleName: row.circleName } })
          }}
        >
          {row.threeTrips?? "N/A"}
        </div>
      ),
    },
    {
      label: "Above 4 Trips",
      field: "above4Trips",
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "4",
              ZoneId: row.circleName === "Total" ? "" : row.zoneId,
              CircleId: row.circleName === "Total" ? "" : row.circleId,
            }
            fetchTripDetails(params)
            navigate("/sat-inner-trip-report", { state: { ...filters, colName: "Above 4 Trips", circleName: row.circleName } })
          }}
        >
          {row.above4Trips?? "N/A"}
        </div>
      ),
    },
    {
      label: "Quantity in MT(Est)",
      field: "quantityinMTEst",
      render: row => row.quantityinMTEst?? "N/A",
    },
  ];

  return (
    <div>
      <div className="top-header page-title">
        <span>Circle Wise SATs Reports ({filters?.FromDateTime ? formatDateTimeWithoutSec(filters?.FromDateTime) : getCurrentDateTime()} To {filters?.ToDateTime ? formatDateTimeWithoutSec(filters?.ToDateTime) : getCurrentDateTime()}) (at {getCurrentDateTime1()})</span>
      </div>
      <div className="card mt-3">
        <div className="">
          <CircleWiseFilterForm />
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "-40px", marginBottom: '10px' }}>
            <ExportCircleWiseReport />
          </div>
          <MUITable
            hasTotalRow
            needSRNumber
            columns={circleWiseHeaderColumns}
            rows={circleWiseTrips}
            tableHeight={500}
          />
        </div>
      </div>
    </div>
  )
}




